import { Theme as SharedJSTheme } from "@pg-flex/shared-js/theme";
import { FC, ReactNode } from "react";

import { variables } from "./variables";

type Props = {
  children: ReactNode;
};

export const Theme: FC<Props> = ({ children }) => {
  return <SharedJSTheme variables={variables}>{children}</SharedJSTheme>;
};
